/**
 * @generated SignedSource<<7ba20302afba026cbffcbac47924d0a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TestCustomMcpServerOverridesInput = {
  authType?: string | null | undefined;
  credentials?: string | null | undefined;
  id: any;
  url?: string | null | undefined;
};
export type McpServersOnboardingContentTestOverridesMutation$variables = {
  input: TestCustomMcpServerOverridesInput;
};
export type McpServersOnboardingContentTestOverridesMutation$data = {
  readonly testCustomMcpServerOverrides: {
    readonly error: string | null | undefined;
    readonly success: boolean;
    readonly tools: ReadonlyArray<string>;
  };
};
export type McpServersOnboardingContentTestOverridesMutation = {
  response: McpServersOnboardingContentTestOverridesMutation$data;
  variables: McpServersOnboardingContentTestOverridesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TestConnectionPayload",
    "kind": "LinkedField",
    "name": "testCustomMcpServerOverrides",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tools",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "McpServersOnboardingContentTestOverridesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "McpServersOnboardingContentTestOverridesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bb2454bc391ebf44f290736f8963ace1",
    "id": null,
    "metadata": {},
    "name": "McpServersOnboardingContentTestOverridesMutation",
    "operationKind": "mutation",
    "text": "mutation McpServersOnboardingContentTestOverridesMutation(\n  $input: TestCustomMcpServerOverridesInput!\n) {\n  testCustomMcpServerOverrides(input: $input) {\n    success\n    tools\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "49b9b97e3dbe1292e7d38957ac00fda9";

export default node;
